module.exports = __webpack_public_path__ + "media/close-grey.80d0ae7f.svg";